import React from "react"
import PropTypes from "prop-types"
import CaretDownIcon from "../../../assets/CaretDownIcon"
import CaretUpIcon from "../../../assets/CaretUpIcon"
import * as styles from "./Accordion-tw-styles"
import { gaEventClasses } from "../../../constants/gtm.constants"

const style = styles.defaultStyle

const Accordion = ({ children }) => {
    return <div className={style.container}>{children}</div>
}

Accordion.propTypes = {
    children: PropTypes.node,
}

const AccordionItem = ({ id, isOpen, onToggle, children }) => {
    return (
        <React.Fragment>
            {React.Children.map(children, child => React.cloneElement(child, { isOpen, onToggle, id }))}
        </React.Fragment>
    )
}

AccordionItem.propTypes = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    isOpen: PropTypes.bool,
    onToggle: PropTypes.func,
    children: PropTypes.node,
}

const AccordionTrigger = ({ id, isOpen, onToggle, label }) => {
    const gaEventClass = gaEventClasses.button_click
    const gaEventLabel = label

    return (
        <button
            className={`${style.button} ${isOpen ? style.buttonOpen : ""} ${gaEventClass}`}
            onClick={() => onToggle(id)}
            aria-expanded={isOpen}
            aria-label={`Toggle ${id} section`}
            data-action-detail={gaEventLabel}
        >
            <span className={style.label}>{label}</span>
            {isOpen ? (
                <CaretUpIcon color="#FFFFFF" width="24" height="20" className={`${style.icon} ${style.iconOpen}`} />
            ) : (
                <CaretDownIcon color="#FFFFFF" width="24" height="20" className={style.icon} />
            )}
        </button>
    )
}

AccordionTrigger.propTypes = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    isOpen: PropTypes.bool,
    onToggle: PropTypes.func,
    label: PropTypes.string,
}

const AccordionContent = ({ isOpen, children }) => {
    return (
        <div className={`${style.content} ${isOpen ? "max-h-full opacity-100" : "max-h-0 opacity-0"}`}>{children}</div>
    )
}

AccordionContent.propTypes = {
    isOpen: PropTypes.bool,
    children: PropTypes.node,
}

export { Accordion, AccordionItem, AccordionTrigger, AccordionContent }
